

































































































































































































































import { CustomerContractRate, ICustomerContractRate } from "@/models/customer-contract-rate.entity";
import { numberHigherRule } from "@/lib/rules/numberHigherRule";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { ContractBillingTypeEnum } from "@/lib/enum/contract-billing-type.enum";
import { BillingModeEnum } from "@/lib/enum/billing-mode.enum";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CustomFieldBoolean from "../report/CustomFieldBoolean.vue";

@Component({
  components: {
    CustomFieldBoolean
  }
})
export default class CustomerContractForm extends Vue {
  @Prop({ required: true }) value!: ICustomerContractRate;
  @Prop({ default: false }) isEditing!: boolean;

  localDetails: ICustomerContractRate = new CustomerContractRate({});

  readonly CurrencyEnum = CurrencyEnum;
  readonly ContractBillingTypeEnum = ContractBillingTypeEnum;
  readonly BillingModeEnum = BillingModeEnum;

  @Watch("value", { immediate: true, deep: true })
  onDetailsChange(val: ICustomerContractRate) {
    this.localDetails = val;
  }

  @Watch("localDetails", { deep: true })
  onLocalDetailsChange() {
    this.$emit("update:value", this.localDetails);
  }

  onFieldChanged(labelKey: string) {
    if (!this.isEditing) return;
    this.$emit("field-changed", labelKey);
  }

  get greaterThanZeroRule() {
    return [numberHigherRule(0)];
  }

  get billingTypeItems() {
    return [
      { text: this.$t("objects.contract.customer.BillingTypeEnum.FlatRate"), value: ContractBillingTypeEnum.FlatRate },
      { text: this.$t("objects.contract.customer.BillingTypeEnum.Monthly"), value: ContractBillingTypeEnum.Monthly }
    ];
  }

  get billingModeItems() {
    return [
      { text: this.$t("objects.contract.customer.BillingModeEnum.Individual"), value: BillingModeEnum.Individual },
      { text: this.$t("objects.contract.customer.BillingModeEnum.Collective"), value: BillingModeEnum.Collective }
    ];
  }
}
